import React, { useEffect, useState } from "react";
import { useFileQuery } from "@query/fileQuery";

const PlainImageViewer = ({
  fileUuid,
  className = "",
  style = {},
  imageStyle = {},
  renderCustom,
  alt = "File preview"
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileQuery = useFileQuery(fileUuid);

  useEffect(() => {
    if (fileQuery.isSuccess && fileQuery.data?.data instanceof Blob) {
      const url = URL.createObjectURL(fileQuery.data.data);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [fileQuery.data, fileQuery.isSuccess]);

  if (!fileUuid) return null;

  return (
    <div className={className} style={{ textAlign: "center", ...style }}>
      {fileQuery.isLoading && <div>Loading...</div>}
      {fileQuery.isError && <div style={{ color: "red" }}>Failed to load file.</div>}

      {fileQuery.isSuccess && previewUrl && (
        renderCustom ? (
          renderCustom({
            fileUuid,
            fileBlob: fileQuery.data?.data,
            fileUrl: previewUrl
          })
        ) : (
          <img
            src={previewUrl}
            alt={alt}
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
              display: "block",
              margin: "0 auto",
              ...imageStyle
            }}
          />
        )
      )}
    </div>
  );
};

export default PlainImageViewer;
